
import Post13Summary from "../summary/Post13Summary";

const Post13 = (lang, smallScreen) => {
	let content
	let width= smallScreen? "90%": "600px"
	let widthSmall = "300px"
	if (lang === 'rom') {
		const romText = `
# O lumina puternica - anii copilariei si adolescentei

M-am străduit să spun povestea bunicii mele materne, Aurelia, fără să fac din ea o figură tragică. Merită mai mult decât sa fie definită de asta. Așa că spun repede că s-a născut în ianuarie 1918, după ce tatăl ei a murit în primul război mondial și a murit în decembrie 1945, la scurt timp după ce a născut pe primul ei copil, Mariana, mama mea. Dar în acești nici 28 de ani a trăit și realizat multe.

Ceea ce mi-a rǎmas de la ea sunt vreo 40 de fotografii, trei mici picturi pe care le-a făcut ea, câteva piese de costume populare și un număr de povești.
Ce știu despre Aurelia vine de la mama, evident. La randul ei, mama le-a auzit de la bunica ei, Constanța, mama Aureliei (povestea Constantei [aici](.letters?lang=${lang})) si de la alte cateva rude.

Chiar și eu am avut o astfel de poveste. Aurelia avea o verișoară cu care era prietena. Am întâlnit-o și eu de câteva ori pe această ruda în copilărie, cel mai memorabil cand aveam, cred, vreo 10 ani. Verișoara aceasta, pe atunci o batrânǎ, ne povestea de Aurelia, cât de inteligentă, bună, talentată și carismatică a fost si, adresându-se fiicei ei, Vivi Aurelia(!) și mamei mele, zice: _„Vorbesc cu Aurelia adeseori. Așa cum voi doua vorbiți la telefon, aşa vorbesc și eu cu ea”_. 
M-a bufnit râsul cu gândul la această linie telefonică directă către viața de apoi dar nu m-a bǎgat nimeni in seamǎ. Afecțiunea acestei verisoare era doar pentru Aurelia și nu includea pe fiica ei(pot ghici de ce), ceea ce face următorul intimplare și mai surprinzătoare. In 1998, eram studenta postuniversitara în America și mama m-a vizitat  a doua oară. Neașteptat, mama a avut nevoie de o operație majoră pe inimă, bypass cvintuplu. A fost o perioadă foarte dificilă și ultimul lucru la care m-am gândit atunci a fost săinformez pe aceasta verisoara de operație. Din fericire, mama a supraviețuit operației, și-a revenit și când s-a întors la București, a primit la scurt timp un telefon (pe linie normală!) 
de la această verișoară de-a doua a ei. Înainte ca mama să poată să spună ceva de operație, Vivi a zis: _„in sfârsit!, bine ca te-am prins ca sun de nu stiu cand. Mama mă bate la cap: a avut un vis și Aurelia i-a spus că nu ti-e bine. Ce mai faci, cum esti?"_. Ce sa mai zic și eu, mai știi cum e cu liniile astea telefonice în direct cu viața de apoi?

Revenind la povestea bunicii mele, Aurelia. Cu toată tragedia de a nu-și cunoaște niciodată tatăl erou al războiului de întregire națională, cred că viața  ei a fost destul de fericită în copilărie și adolescență. A avut o mama, Constanta, iubitoare și înțeleaptă. Financiar o duceau bine, aveau o bună poziție socială în comunitatea lor atât datorită sacrificiului tatălui ei, cât și a statutului Constantei de invatatoare respectată, numita „Doamna” în sat. 
Au avut și sprijinul neamurilor care locuiau în același județ, cunosteau familiile instarite din zona. 

Aurelia a urmat școala primară în satul ei și a avut-o pe mama ei ca invatatoare.
Am câteva fotografii din anii de școală ai bunicii mele. Acestea sunt fotografii de studiou fotografic, probabil făcute la Pitești. In ele, Aurelia  poartă fie o uniformă școlară, fie un costum popular, uneori apare cu alte fete, probabil verisoare sau prietene de școală. Am încercat să colorez unele dintre fotografii pentru a vedea mai bine cum arătau acele uniforme, costume și haine.
<figure>
<img src="./post13/first.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	<figcaption style="text-align: center;" ><i>Prima fotografie a bunicii mele, Aurelia
	</i></figcaption>
</figure>

Alte fotografii de studio, mi-a plăcut că a pozat cu o carte în prima fotografie.

<figure>
<img src="./post13/studioalone.jpg"
	style="display: block; margin: auto; width: ${width}" />
	</figure>
Aici Aurelia ce alături de alte fete, probabil neamuri, ea este în dreapta în prima fotografie si-n stanga în a doua.
<figure>
<img src="./post13/studioothers.jpg"
	style="display: block; margin: auto; width: ${width}" />
	</figure>
Am doua dintre iile ei, una din ele  apare în aceasta fotografie și m-am îmbrăcat si eu ​​o dată cu ea, și la fel a făcut și unul dintre fiii mei la o serbare, largimea iiei a făcut să se potriveasca, și pentru copil, și pentru adult.
<figure>
<img src="./post13/meandher.jpg"
	style="display: block; margin: auto; width: ${width}" />
	</figure>
Am și un portret mare înrămat al ei care pare să fie din această epocă. Nu eu am colorizat aici, fotograful probabil ca a facut, de mâna. Acesta e unul din obiectele la care mă uităm când eram rācita cum am povestit [aici](/.look?lang={lang})
<figure>
<img src="./post13/framed.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	</figure>

Această fotografie, destul de deteriorată, o înfățișează pe bunica mea, a treia pe rândul de sus, în primul an la școala gimnazială din capitala județului Pitești. Există un scris pe verso, suficient de lizibil încât să-i descifrez numele, Aurelia Plesoianu, clasa 1 de liceu( echivalentul clasei a 5a de acum) și orasul, Pitești. Evident, o școală de fete. Bănuiam ca a fost la Pitești dar suficiente litre supraviețuiesc sa confirme asta. 
Vad ca-ti trebuie acum 50 de minute in zilele noastre sa ajungi cu masina din satul ei pînă la Pitești, probabil a stat cu rude. Verișoara ei care o pomenea zeci de ani mai tîrziu era din oraș si probabil ca prietenia lor datează de atunci.
<figure>
<img src="./post13/school.jpg"
	style="display: block; margin: auto; width: ${width}" />
	<figcaption style="text-align: center;" ><i>Scoala normala
	</i></figcaption>
</figure>
Am gasit un [articol]((Biblioteca Digitală
https://biblioteca-digitala.ro
PDF
evoluţia învăţământului la piteşti în perioada interbelică (1919-1939)) despre invatamantul interbelic in Argeș care spune: școala normală de fete din Piteşti a dat prima promoţie de absolvente cu 8 clase,  formată din 40 de învăţătoare, la 15 iunie 1936. Aurelia trebuie sa fi fost una din aceste absolvente pentru ca acesta e anul absolvirii. Am numarat 60 de fetite in fotografie. Se înțelege ca 20 dintre ele s-au apropiat pe parcurs si nu au absolvit.
<figure>
<img src="./post13/backofschoolphoto.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	<figcaption style="text-align: center;" ><i>Pe verso
	</i></figcaption>
</figure>

Odată cu adolescența, se pare că frumusețea ei a înflorit.
<figure>
<img src="./post13/moviestar.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>

Cred că arată un pic ca o vedetă de film (probabil ca ieșea la cinema) în această fotografie din anii adolescenței, poate și cu un pic de ruj. Am auzit ca ii plăcea sa merga la cinematograf mai tîrziu, ca tinerelor din acea generatie si probabil ca a început sa mearga de la Pitești, unde primul cinematograf s-a deschis în 1912. 

Fotografiile din copilărie sunt făcute la fotograf și sunt mai artificiale, cu decor pictat.  Cele care au urmat sunt mai spontane si ne spun mai multe despre viața ei. Din câte știu, Constanta si Aurelia nu au avut niciodată aparat foto, deci altcineva a adus camera și a făcut fotografiile atât de prețioase pentru mine acum. Asta înseamnă si ca fotografiile sunt un pic aleatorii ca frecventa. Altcineva trebuie sa fi adus aparatul. De exemplu, următoarea fotografie indica o călătorie mai lungă. Nu înseamnă ca e singura calatorie, dar atunci a fost cineva cu un aparat foto.

Îmi place această fotografie a bunicii mele, Aurelia e la mijloc, cu doi prietene și, pe fundal, un memorial dedicat soldaților care au murit în Primul Război Mondial in jurul Predealului. Se poate citi textul cu zoom. 
Nu știu de celelalte fete,  pentru Aurelia, era ca și cum  își vizita tatăl și un scurt moment de exuberanță tinerească este de iertat tinand cont de pierderea pe care a suferit-o. Mă bucur să o văd zâmbind și distrându-se decât să fie solemnă cum poate ar fi mai normal la așa monument. 
Atât de multă tragedie în viața ei, bine ca a fost si veselă.

<figure>
<img src="./post13/monument.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
Am căutat monumentul din Predeal si am găsit aceasta fotografie recenta( copyright -ul celui care a facut-o). Comparînd monumentele, emblema regalǎ din fotografia bunicii a fost inlocuita, probabil de comunisti, cu imaginea cu casca, nici nu știu dacă e corecta pentru primul război mondial. Precis crucea a fost adaugata 1990. Bieții soldati eroi, atîta politica, efectiv pe oasele lor.
<figure>
<img src="./post13/monumentnew.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
</figure>

Predeal nu-i așa aproape de Argeș si Pitești. Vad 3 ore cu masina sau 4 ore jumătate cu trenul în zilele noastre. Cum o fi ajuns acolo? Sa fie o excursie cu școala? Se făcea asa ceva in ani ‘30 la școala de fete? Sau o excursie privata? 
Sigur fetele nu calatoreau singure atunci? După cum povestea strabunica mea, mama Aureliei si a ajuns la mine prin mama, aveau o sareta de tipul asta dar probabil pentru distanțe mult mai scurte. Oricum, mă bucur sa vad aceasta dovada ca Aurelia a ajuns la Predeal unde am fost și eu de multe ori.
<figure>
<img src="./post13/sareta.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	<figcaption style="text-align: center;" ><i>
	Credit [autorului](https://m.ghidul.ro/caisitrasuri/produse-servicii/trasuri-47154/sareta-85190)
	</i></figcaption>
</figure>

Am colorizat fotografia asta si se vede mai bine ce poarta, un fel de pantaloni, care arată mult mai moderni în comparație cu ce poarta prietenele ei, îmi pare rău sa zic, fetelor!  Potrivit diverselor resurse pe care le-am găsit, purtarea pantalonilor la acea vreme,  1932, era destul de îndrăzneață. Tinînd cont de vârsta foarte tânără, mama ei trebuie sa fi aprobat, plătit pentru aceasta ținută.
De exemplu, în acest [articol de ziar](https://adevarul.ro/stiri-locale/alexandria/femeile-si-masculinizarea-cand-au-inceput-de-1776180.html#google_vignette
) se spune că primul tip de pantaloni pe care l-au purtat româncele emancipate au fost pantaloni harem. Acesta sa fi fost numele pentru ceea ce poartă ea? Pe străzile din București, primele doamne au început să le poarte din 1928, dar a existat o rezistență socială puternicǎ la aceasta tendinta. 
 Imi place ca cinci ani mai târziu si la 15 ani, ea purta pantaloni. Chiar si pantofii, atit cit se vad, par comfortabili, aproape sport. Asta e singura fotografie in care Aurelia poarta pantaloni. Poate a fost o faza de adolescenta, dar imi place mult sa vad asta. Bravo ție, bunico!
<figure>
<img src="./post13/detail.png"
	style="display: block; margin: auto; width: ${widthSmall}" />
</figure>

Aurelia a făcut parte din mișcarea cercetaselor așa cum arată aceste fotografii cu ea în uniformă, în fața casei ei.  Citind aici, de exemplu, pe [blogul log](
https://cercetasia.blogspot.com/2011/01/primele-cercetase.html), în România, organizația de cercetaşe a fost înființată în 1930, când Aurelia avea 12 ani, deci organizația era destul de nouă când a luat parte la ea. În prima poza pare foarte tânără, in preadolescenta, pare sa fie fost printre primele cercetase. A doua fotografie e datata 1 septembrie 1940,  cind avea 22 de ani, deci a continuat sa facă parte din organizație si ca adulta, ghidind alte generatii.
<figure>
<img src="./post13/guides.jpg"
	style="display: block; margin: auto; width: ${width}" />
	<figcaption style="text-align: center;" ><i>
	Bunica mea în uniformă de cercetasa, în fața casei ei în două ocazii diferite.
	</i></figcaption>
</figure>



Deloc surprinzător, tânăra Aurelia a început să fie curtată și a avut propuner de căsătorie destul de devreme. Este amuzant să vezi unele dintre obiceiurile sociale ale acelei epoci reflectate în fotografiile ei. 
Evident, nu mă interesează sa barfesc oameni duși de mult, dar am o anume curiozitate sociologica. Mi-am dat seama că știu mai multe despre moravurile, de exemplu, din timpul Regentei in Anglia, prin cărțile si ecranizarile dupa Jane Austen, decat știu cum se comportau oamenii din aceasta clasa sociala in Romania interbelica, cind am doar cateva romane ca punct de referinta.

Am câteva fotografii din aceasta perioada a vieții ei care au pe spate mesaje de la tineri în stilul galant al vremei. Se pare că a face fotografii și a le da înapoi fetei cu un mesaj romantic, scriind ca pe o vedere, a fost o modalitate de a face curte atunci.

De exemplu, această fotografie o înfățișează pe Aurelia cu mama ei, Constanta acasă la ele și un tânăr, însoțit de tatăl său, vine să-i ceară mâna Aurelei. Cum de exista aceasta fotografie? Au adus cei doi bǎrbați un aparat foto și un fotograf pentru aceasta ocazie? Pare ca anticipau un raspuns favorabil. Fotografie e datata  27 august 1935 când Aurelia avea 17 jumatate ani. Interesant ce purtau cu toții pentru aceasta ocazie: costume și cravate pentru barbati, port popular pentru mama si un deux-piece mai tradițional pentru fata care o face sa para mai în varsta decat anii ei.
<figure>
<img src="./post13/proposal.png"
	style="display: block; margin: auto; width: ${width}" />
</figure>

Mai sunt si alte doua fotografii care imi plac mult. In prima, Aurelia e în dreapta cu prietenele ei. În mod evident, măsuța și scaunele au fost aduse afară pentru ca fetele să se bucure de soare, cu ceea ce arată ca o prajitura și niște băuturi răcoritoare. Casa avea o verandă, dar trebuie să fi vrut să stea afară.  Imi place bluza cu in combinatia de carouri pe care o poarte Aurelia si gulerul jabou. Probabil ca nu sunt obiectiva, dar pare cu un pas înainte în ale modei comparativ cu prietenele ei.
<figure>
<img src="./post13/friends.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
Mesajul pe spatele fotografiei spune  “Expresia traduce caracterul, ochii sufletul iar amandoua omul. Cine ar fi crezut ca sunt chiar eu fotograful?”. Semnătura include un titlu “pretor” de care nu mai auzisem. Suna a ceva de origine romana, e o functie sub prefect, conducatorul unei plase, o diviziune administrative a judetului. 
Tânărul trebuie sa fi crezut ca e foarte impresionant ca sa-si includa titlul într-un context romantic.


O a doua fotografie cu aceeași ocazie o înfățișează pe Aurelia în dreapta și il include pe fratele unuia dintre ele, autorul mesajelor. 
<figure>
<img src="./post13/withpretor.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
De data asta, mesajul zice: “Ceeace pe unii îi îndepărtează, pe altii ii apropie. Și totuși extremele dovedesc ca ceea ce este departe, poate fi și aproape, cu toate ca cineva dintre oi ne spionează pe amândoi”. 
Poate era o gluma, desi finalul suna bizar. Mie imi sunǎ pretențios şi cam antipatic dar poate aşa era
normal atunci şi probabil toti am vorbit sau scris bazaconii cînd incercam sa 
impresionǎm pe cineva care ne place.
<figure>
<img src="./post13/backofphoto.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
Aceste ultimele doua fotografii cu mesajele lor sunt datate 30 august 1937 si au ca locatie un sat de langa al ei. Ca si cronologie, fotografiile acestea sunt după ce s-a mutat la București și a venit înapoi in vizita într-o vară, dar le-am inclus acum căci se potrivesc la subiectul obiceiurilor romantice ale vremii și 
ca locatie rurala.  

Aurelia nu s-a maritat de foarte tinara. Luminile stralucitoare ale Bucurestiului, pe atunci micul Paris, au atras-o. După ce a terminat scoala normala din Pitesti in 1936, s-a mutat la București.

Mi-a plăcut mult ce am descoperit in aceste fotografii și cu cateva cautari simple pe internet. Mi-a plăcut să descopăr că era modernă și implicată în lucruri și instituții noi, de la prima promotie a scolii, la pantaloni, cercetasie, excursie, moda. 
Una o fi o intamplare, dar toate indica o anume personalitate, o deschidere spre nou, indrǎznealǎ și curaj, inclusiv din partea mamei ei care a sustinut-o in toate acestea.
Ce s-a întâmplat mai departe în această viață scurtă, dar plinǎ, va fi subiectul următoarei mele povestiri.



`
		content = romText
	} else { 
const postText = `
# Shining brightly - the early years

I had to try hard to tell the story of my maternal grandmother, Aurelia, without making her a tragic figure. 
She deserves more than that. 
So let me say quickly that she was born in January 1918 after her dad had died in WW1 and she died in December 1945 soon after she gave birth to her first child, Mariana, my mother. 
But she packed a lot in these not quite 28 years.

What I have of her are about 40 photos, three of her gouaches and a few folk costumes pieces.
Most of the information I have on Aurelia comes, obviously, from my mother. 
She got it herself from her grandmother, Constance, Aurelia’s mother(her story [here](./letters?lang=${lang})) and from a few other relatives.
Even I had one such story. Aurelia had a cousin that she was close to. 
I met this cousin a few times, most memorably, when I was about ten years old. 
The cousin, at that time an old lady, seems to have had a bit of a  life-long girl crush on Aurelia and was
 saying how clever, kind, talented and charismatic my grandmother had been. 
 Addressing her daughter, Vivi ( middle name Aurelia!) and my mother, she said _“I speak to Aurelia all the time. It’s like you two speak on the phone”_. 
 The thought of this direct phone line to the afterlife was very funny to me at the time so I started laughing but they didn’t pay me any attention. 
The cousin’s affection did not extend from Aurelia to, her daughter, my mother which makes the next bit even more surprising. 
Much later, in 1998, when I was a postgraduate student in America and my mother was visiting me, she, unexpectedly, needed a major heart surgery, 
quintuple bypass. 
It was a very stressful time and the last thing on my mind was to inform the cousins. 
Thankfully, my mother recovered and, eventually, got home. As soon as she was back, she got a phone call (on a normal landline!) 
from this cousin of hers, once removed. 
Before my mother got the chance to say anything, Vivi blurted _“Phew, I am so glad to catch you. 
I have been calling for ages. Mum was nagging me to call you all the time. She had a dream and Aurelia told her you were in trouble. 
How are you?”_. OK, what do I know to make fun of afterlife phone lines?


Back to my grandmother's story. I will tell the story of Aurelia’s early years through the photos I have. 
For all the tragedy of never knowing her war hero father, I think her upbringing was quite happy, under the care of her loving and wise mother, Constance. 
They were quite well off, 
and had a good social standing in their community  with Constance the respected teacher of the primary school and known as “The lady” in the village 
(even I heard this name on one rare visit to the village during my childhood). 
They also had the support of their extended family living in the same county and knew socially the better-off families in the area.

Aurelia attended primary school in her village and was taught by her mother. 
I have a few photos of my grandmother's early school years. 
These are studio photos: she is either wearing a school uniform or a folk costume, sometimes with other girls, 
likely cousins or school friends. I tried to colourise some of the photos to get a feel for the uniforms, costumes and clothes.

This is the earliest photo I have of my grandmother, in her primary school uniform.
<figure>
<img src="./post13/first.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	<figcaption style="text-align: center;" ><i>First photo of my grandmother, Aurelia
	</i></figcaption>
</figure>
Other photos from the studio, including this one with a book as a prop.
<figure>
<img src="./post13/studioalone.jpg"
	style="display: block; margin: auto; width: ${width}" />
	</figure>
Here is my grandmother posing with other girls, possibly extended family, she is on the right in the first and on the left in the second:
<figure>
<img src="./post13/studioothers.jpg"
	style="display: block; margin: auto; width: ${width}" />
	</figure>
I have her blouse (a traditional Romanian folk top called ia) and I wore it two years ago for a work event and so did one of my sons for a school event, the forgiving nature of the garment means it just about fit both child and woman.
<figure>
<img src="./post13/meandher.jpg"
	style="display: block; margin: auto; width: ${width}" />
	</figure>
I also have a large framed portrait of Aurelia from this era. This one is not my colourisation, it must have been done by hand by the photographer. 
This is the portrait I was looking at while poorly as I described [here](./look?lang=${lang})
<figure>
<img src="./post13/framed.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	</figure>
This rather battered photo below shows my grandmother, third on the top row in her first of the eight years at the normal school (teacher training) in the county capital, Pitesti. 
She must have been around 11 years old.
Clearly it was a girls’ school.
I found a little [paper]((Biblioteca Digitală
https://biblioteca-digitala.ro
PDF
evoluţia învăţământului la piteşti în perioada interbelică (1919-1939)) on education in Arges county in the interwar period  and 
it says the normal school for girls in Pitesti had the first graduating class of 40 new teachers in June 1936. 
The dates fit, Aurelia must have been one of those 40. 
This also makes me wonder where her mother, Constance, studied to become a teacher if this school did not exist a generation before.
She must have travelled a lot further.
I counted 60 girls in this photo in year 1. The other 20 must have stopped before reaching year 8.
<figure>
<img src="./post13/school.jpg"
	style="display: block; margin: auto; width: ${width}" />
	<figcaption style="text-align: center;" ><i>Secondary school
	</i></figcaption>
</figure>
There is a writing on the back, readable enough to decipher her name, Aurelia Plesoianu, year 1 
(the numbering system goes back to 1 after primary school)  and the place, Pitesti. 
I like it that enough it’s left on the back  to confirm it’s her, the date and place. 
It’s like something from a novel, enough letters ‘Pite’ surviving to work out a simple clue, the name of the town that
is the county capital Pitesti. If more of the corner was gone, I'd have guessed the town,  but nice to see it confirmed. 
There are 50 minutes by car today from her village to Pitesti so she must have stayed in the town, likely with relatives. 
Her cousin that remembered her vividly all those years later was from this town, so this must have been the beginning of their friendship.
<figure>
<img src="./post13/backofschoolphoto.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	<figcaption style="text-align: center;" ><i>Back of the school photo
	</i></figcaption>
</figure>
With adolescence, it looks like her beauty blossomed.
<figure>
<img src="./post13/moviestar.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
I think she looks a bit like a movie star in this photo from her teenage years, maybe a bit of a pout and lipstick too. 
I know she liked to go to see films later, like most young people from that time. 
There were cinemas in Pitesti, the oldest is from 1912 and I think it is likely she started going as a teenager.

Most of the photos until now were done at a photographer studio. 
They are nice but more artificial in my view. The later ones are more spontaneous and interesting. 
As far as I know, Aurelia and her mother never had a camera so someone else brought a camera along, took the photos and gifted them 
these photos that I now cherish. So, the frequency might be a bit random. 
For example, I see evidence of a longer trip Aurelia took from one photo described below, but I don’t think 
it means it was the only trip, more that this is the time when there was someone with a camera to record it. 

I love this photo of my grandmother though for current sensibilities, it could look a bit disrespectful. 
It shows Aurelia in the middle, with two friends against a WW1 memorial representing soldiers that died in the battle around a place called Predeal. 
Zooming in, it is possible to read the text on the monument, including the location.

<figure>
<img src="./post13/monument.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
I am not sure about the other girls, but she was sort of visiting her dad and a brief moment of youthful exuberance is to be 
forgiven for all the loss they suffered. I am glad to see her smile and enjoying herself rather than being solemn. 
So much tragedy in her life, it’s lovely to see her looking happy.

I looked up the monument and found this recent photo of it (credit to the photo owner)
<figure>
<img src="./post13/monumentnew.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
</figure>
The royal crest with the crown from the old photo must have been taken out by the communists and 
replaced with the puny helmet. 
I am not sure if it’s even historically accurate for WW1. I bet the cross was added after 1990. 
So much politics on, literally, the bones of those poor heroes.

The monument is not too close to the county Aurelia was in at the time: 3 hours by car or 4:30 by train if you travel today. 
Was this a school trip? Was this a thing in a ’30s girl school? A private trip? Surely three teenagers would not travel alone. 
Anyway, I am glad to see evidence that she got to Predeal where I went many times too.
According to my great-grandmother Constance, via my mother, Constance and Aurelia had one of these small carriages 
like this one but they, probably, used it for shorter distances.
<figure>
<img src="./post13/sareta.jpg"
	style="display: block; margin: auto; width: ${widthSmall}" />
	<figcaption style="text-align: center;" ><i>
	Photo credit to the [owner](https://m.ghidul.ro/caisitrasuri/produse-servicii/trasuri-47154/sareta-85190)
	</i></figcaption>
</figure>
I tried a bit of colourisation of this photo and, while I am not sure the colours are right, it makes it more obvious that 
she is wearing some sort of slacks, trousers that look so much more modern compared to her friends, sorry, girls. 
<figure>
<img src="./post13/detail.png"
	style="display: block; margin: auto; width: ${widthSmall}" />
</figure>
Considering how young she was in this photo, her mum must have approved and paid for the outfit, which is pretty cool.  
According to various resources, wearing trousers at that time, in 1932, was quite daring. 
For example, in this [newspaper article](https://adevarul.ro/stiri-locale/alexandria/femeile-si-masculinizarea-cand-au-inceput-de-1776180.html#google_vignette) it says that 
the first type of trousers that emancipated Romanian women wore were harem pants. Is this the name for what she is wearing?
 On the streets of Bucharest, the first ladies started to wear these from 1928 but there was a lot of social resistance to it.
So four years after the first women of the country wore trousers, here she is doing it at 15, I think it is pretty cool. 
Even the shoes, as much as you can see them, look like some comfortable, almost sport shoes. 
In no other photo, Aurelia wears trousers. Maybe it was a rebellious teenage phase, but lovely to see.  Good for you, grandma!


Aurelia was a member of the Girl Guides movement as these photos of her in the uniform, in front of her house show. 
Looking on their [blog](https://cercetasia.blogspot.com/2011/01/primele-cercetase.html), in Romania, the girl scouts organisation was set up in 1930. 
Aurelia was 12 at the time, so the organisation was quite new when she took part in it. I would say in the left photo she is really young, pre puberty, so she must have been among the first intakes. 
The second photo is dated on the back, 1 september 1940, so she must have been taking part as an adult too at 22.
<figure>
<img src="./post13/guides.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>

Rather unsurprising, young Aurelia started to be courted and had proposals quite early on. 
It is funny to see some of the social customs of that era reflected in the photos in this way. 
Obviously, I am not interested in gossiping about the relationships of long gone people. 
But I am curious about the social mores of that era as reflected from these photos. 
I realised that I know more about, say,  the courtship, friendships, relationships, marriage rules in Regency England 
through the Jane Austen adaptations than the more recent, interwar period, 
in my own country, except for a few novels that do not cover her social class, they go either higher or lower. 
So my curiosity is a bit anthoropological as well as personal.

There are a couple of photos from this stage and they have on the back decorous courting messages, written like on a postcard.
It must have been an option at the photographer to have it printed with the markings of a postcard on the back of the photo.
It seems taking photos and giving them back to the girl with a romantic message was a way a form of courthship.

For example, this photo shows Aurelia with her mother, Constance at their home and a young man and his dad 
as the young man came to ask for Aurelia hand in marriage. 
Did the men bring a camera and a photographer around? That seems a bit overconfident. 
There is a date on the back, 27 august 1935, when Aurelia was 17. 
Interesting what they were all wearing for this occasion: suits and ties for men, 
a traditional folk attire for the mother and a more urban but conservative attire for the girl that made her look older than her years. 
Do I read to much in this photo is I say she looked less than ecstatic? 

<figure>
<img src="./post13/proposal.png"
	style="display: block; margin: auto; width: ${width}" />
</figure>
This was the last summer, between year 7 and 8, of the normal school( teacher training school).

Then, there are two other photographs. The first shows Aurelia  on the right having fun and refreshments  with her friends.
<figure>
<img src="./post13/friends.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
The little table and chairs, with the little tablecloth, were clearly just brought outside for the girls to enjoy the sun with what looks like 
cake and some cooling drinks. 
The house had a veranda, but they must have wanted to sit outside. 
I rather like her checked top and jabot( if that's correct) collar. 
Obviously I am biased, but she looks more fashionable than her friends.
So, this is how girls of a certain class would socialise.

The message on the back: “The expression shows the character, the eyes reveal the soul and both the person. 
Who would think I was the photographer?” There is a date, place and signature. 
The place is another village next to hers. 
The signature includes a job title “Pretor”, that I had to look it up. It sounds Roman and this is indeed its origin and it 
was a local government job, the next level down from the county prefect. 
The young man must have thought it was impressive enough to include it in a romantic context.

From the same occasion, a second photo includes the young man, the brother of one of her friends.
<figure>
<img src="./post13/withpretor.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
The message: “What draws apart some people, brings others together. Still, the extremes show that what is far away can be quite close, 
even if some are spying on both of us”. What???  Maybe it was a joke or maybe you had to be there. 
<figure>
<img src="./post13/backofphoto.jpg"
	style="display: block; margin: auto; width: ${width}" />
</figure>
These last two photos are dated 30 august 1937. 
Strictly speaking, these were during a visit back to the village after she went to Bucharest but I included them here for the theme and location.

Aurelia did not want to marry young. The bright lights of the Paris of the East, at its best in all its modernist, Art Deco glory, were beckoning.

As soon as she graduated with her teaching qualification, Aurelia moved to Bucharest. 
I loved to discover just by looking carefully at these photos and with a few quick searches 
how modern and forward looking my grandmother was, how she was involved with so many brand new things: 
the school, girls guide, fashion choices. Once might be an accident, but this looks more like a pattern.
Her mother must have been onboard with these and supported her all the way.

What happened next in this short but fascinating life will be a subject of my next story.

`
    content = postText
	}


const summary = Post13Summary(lang)
return {
	content,
	linkId: summary.linkId,
	title: summary.cardTitle
}
}

export default Post13;
